import SignUp from "./signUpContainer";
export default SignUp;
